import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface FullScreenModalProps {
    isOpen: boolean;
}
const initialState: FullScreenModalProps = {
    isOpen: false,
};
const FullScreenModalSlice = createSlice({
    name: 'FullScreenModalSlice',
    initialState,
    reducers: {
        setFullScreenModalOpen: (state, action: PayloadAction<boolean>) => {
            state.isOpen = action.payload;
        },
    },
});

export const { setFullScreenModalOpen } = FullScreenModalSlice.actions;
export default FullScreenModalSlice.reducer;
